var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v("Proforma " + _vm._s(_vm.numero_documento))]),
          _vm._v(" "),
          _c("label", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "A",
                    expression: "estado === 'A'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_c("strong", [_vm._v("ANULADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.estado === undefined ||
                        _vm.estado === null ||
                        _vm.estado === "AUT") &&
                      _vm.facturada === "N",
                    expression:
                      "((estado === undefined || estado === null || estado === 'AUT') && facturada === 'N')"
                  }
                ],
                staticClass: "noti-info"
              },
              [_c("strong", [_vm._v("EMITIDO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.facturada === "S" && _vm.estado !== "A",
                    expression: "(facturada === 'S' && estado !== 'A')"
                  }
                ],
                staticClass: "noti-success"
              },
              [_c("strong", [_vm._v("FACTURADA")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "N",
                    expression: "estado === 'N'"
                  }
                ],
                staticClass: "noti-secondary"
              },
              [_c("strong", [_vm._v("NUEVO")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c(
            "button",
            {
              staticClass: "btn-bus200 btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.consultarComprobantes }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _vm._v(" "),
              _c("span", [_vm._v("Buscar proformas")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main" }, [
        _c("div", { staticClass: "layout__main-form" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-field select2",
                      class: {
                        "select2--disabled": _vm.editando
                      }
                    },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          { staticClass: "select2-field" },
                          [
                            _c("v-select", {
                              attrs: {
                                label: "descripcion",
                                options: _vm.puntosEmision,
                                id: "punto_emision",
                                placeholder: "Seleccione..."
                              },
                              on: { input: _vm.inputPuntoEmision },
                              model: {
                                value: _vm.selectedPuntoEmision,
                                callback: function($$v) {
                                  _vm.selectedPuntoEmision = $$v
                                },
                                expression: "selectedPuntoEmision"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "punto_emision" } }, [
                              _vm._v("Punto de emisión *")
                            ]),
                            _vm._v(" "),
                            _vm.errores.id_punto_emision
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.errores.id_punto_emision[0])
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("date-picker", {
                          attrs: {
                            disabled: _vm.editando,
                            type: "date",
                            format: "dd-MM-yyyy",
                            id: "fecha_emision",
                            lang: "es"
                          },
                          model: {
                            value: _vm.form.fecha_emision,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_emision", $$v)
                            },
                            expression: "form.fecha_emision"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "fecha_emision" } }, [
                          _vm._v("Fecha de emisión *")
                        ]),
                        _vm._v(" "),
                        _vm.errores.fecha_emision
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.fecha_emision[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            label: "nombre",
                            options: _vm.vendedores,
                            id: "vendedor",
                            placeholder: "Seleccione..."
                          },
                          on: { input: _vm.inputVendedor },
                          model: {
                            value: _vm.selectedVendedor,
                            callback: function($$v) {
                              _vm.selectedVendedor = $$v
                            },
                            expression: "selectedVendedor"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "vendedor" } }, [
                          _vm._v("Vendedor *")
                        ]),
                        _vm._v(" "),
                        _vm.errores.vendedor_id
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.vendedor_id[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "multiselect-field" },
                      [
                        _c(
                          "multiselect",
                          {
                            attrs: {
                              loading: _vm.isLoadingCliente,
                              placeholder: "Escriba y seleccione...",
                              taggable: true,
                              "tag-placeholder": "Nuevo cliente",
                              label: "nombre",
                              "track-by": "id",
                              id: "cliente",
                              options: _vm.clientes,
                              "preserve-search": true,
                              selectedLabel: "Seleccionado",
                              selectLabel: "Presiona enter para seleccionar",
                              deselectLabel: "Presiona enter para eliminar"
                            },
                            on: {
                              input: _vm.inputCliente,
                              "search-change": _vm.onSearchCliente,
                              tag: _vm.addTag
                            },
                            model: {
                              value: _vm.selectedCliente,
                              callback: function($$v) {
                                _vm.selectedCliente = $$v
                              },
                              expression: "selectedCliente"
                            }
                          },
                          [
                            _c("template", { slot: "noOptions" }, [
                              _c("span", [_vm._v("La lista esta vacía")])
                            ]),
                            _vm._v(" "),
                            _c("template", { slot: "noResult" }, [
                              _c("span", [
                                _vm._v(
                                  "No se encontraron elementos. Considere cambiar la consulta de búsqueda."
                                )
                              ])
                            ])
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "cliente" } }, [
                          _vm._v("Cliente *")
                        ]),
                        _vm._v(" "),
                        _vm.errores.codigo_cliente
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.codigo_cliente[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            id: "email",
                            placeholder: "Correo del cliente"
                          },
                          model: {
                            value: _vm.form.email,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "email", $$v)
                            },
                            expression: "form.email"
                          }
                        },
                        [
                          _vm._v(
                            '\n                  E-mail ("," para separar varios)\n                  '
                          ),
                          _vm.errores.email
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.email[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.orden_trabajo != null && _vm.orden_trabajo !== "",
                        expression:
                          "orden_trabajo != null && orden_trabajo !== ''"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                readonly: "",
                                id: "ordenTrabajo",
                                placeholder: "OT"
                              },
                              model: {
                                value: _vm.orden_trabajo,
                                callback: function($$v) {
                                  _vm.orden_trabajo = $$v
                                },
                                expression: "orden_trabajo"
                              }
                            },
                            [_vm._v("Orden de trabajo")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn-info btn--text",
                              on: { click: _vm.verOrdenTrabajo }
                            },
                            [_c("i", { staticClass: "fa fa-eye" })]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            id: "observacion",
                            placeholder: "Escriba una observación..."
                          },
                          model: {
                            value: _vm.form.observacion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "observacion", $$v)
                            },
                            expression: "form.observacion"
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Observación\n                  "
                          ),
                          _vm.errores.observacion
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.observacion[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c("label", { attrs: { for: "mostrar_impuestos" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.mostrar_impuestos,
                            expression: "form.mostrar_impuestos"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "mostrar_impuestos",
                          id: "mostrar_impuestos"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.mostrar_impuestos)
                            ? _vm._i(_vm.form.mostrar_impuestos, null) > -1
                            : _vm.form.mostrar_impuestos
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.form.mostrar_impuestos,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "mostrar_impuestos",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "mostrar_impuestos",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "mostrar_impuestos", $$c)
                            }
                          }
                        }
                      }),
                      _c("span", [
                        _vm._v("Mostrar valores con impuestos en impresión")
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__title" }, [
              _c(
                "div",
                { staticClass: "form-inline" },
                [
                  _c("input-field", {
                    attrs: {
                      id: "searchItems",
                      placeholder: "Consulta de detalle por descripción..."
                    },
                    model: {
                      value: _vm.searchItems,
                      callback: function($$v) {
                        _vm.searchItems = $$v
                      },
                      expression: "searchItems"
                    }
                  }),
                  _vm._v(" "),
                  _c("h5", [_vm._v("Items de la proforma")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [
                _c("tabla-items-proforma", {
                  ref: "tablaItems",
                  attrs: {
                    retencionProductos: _vm.retencion_productos,
                    retencionServicios: _vm.retencion_servicios,
                    errores: _vm.errores,
                    irbpnr: _vm.irbpnr,
                    tarifas: _vm.tarifas,
                    search: _vm.searchItems
                  },
                  on: { updated: _vm.calcularTotales },
                  model: {
                    value: _vm.form.detalles,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "detalles", $$v)
                    },
                    expression: "form.detalles"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card__content" },
                  [
                    _c("tabla-forma-pago", {
                      attrs: {
                        tiposUnidad: _vm.tiposUnidad,
                        totalComprobante: _vm.form.total,
                        errores: _vm.errores,
                        formasPago: _vm.formasPago
                      },
                      model: {
                        value: _vm.form.formasPago,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "formasPago", $$v)
                        },
                        expression: "form.formasPago"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-xs-12 col-md-7" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card__content" },
                  [
                    _c("tabla-informacion-adicional", {
                      attrs: { enviable: "", errores: _vm.errores },
                      model: {
                        value: _vm.form.informacionAdicional,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "informacionAdicional", $$v)
                        },
                        expression: "form.informacionAdicional"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-5" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_sin_impuestos",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.total_sin_impuestos,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total_sin_impuestos", $$v)
                                },
                                expression: "form.total_sin_impuestos"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal S/I\n                      "
                              ),
                              _vm.errores.total_sin_impuestos
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores.total_sin_impuestos[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "descuento_total",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.descuento_total,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "descuento_total", $$v)
                                },
                                expression: "form.descuento_total"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Descuento total\n                      "
                              ),
                              _vm.errores.descuento_total
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.descuento_total[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_no_iva",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.subtotal_no_sujeto_iva,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "subtotal_no_sujeto_iva",
                                    $$v
                                  )
                                },
                                expression: "form.subtotal_no_sujeto_iva"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal N/IVA\n                      "
                              ),
                              _vm.errores.subtotal_no_sujeto_iva
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores
                                              .subtotal_no_sujeto_iva[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_e_iva",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.subtotal_exento_iva,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "subtotal_exento_iva", $$v)
                                },
                                expression: "form.subtotal_exento_iva"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal E/I\n                      "
                              ),
                              _vm.errores.subtotal_exento_iva
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores.subtotal_exento_iva[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "total_irbpnr",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.total_irbpnr,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total_irbpnr", $$v)
                                },
                                expression: "form.total_irbpnr"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Total IRBPNR\n                      "
                              ),
                              _vm.errores.total_irbpnr
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.total_irbpnr[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_iva",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.subtotal_iva,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "subtotal_iva", $$v)
                                },
                                expression: "form.subtotal_iva"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal IVA\n                      "
                              ),
                              _vm.errores.subtotal_iva
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.subtotal_iva[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_iva_0",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.subtotal_iva_0,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "subtotal_iva_0", $$v)
                                },
                                expression: "form.subtotal_iva_0"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal IVA 0%\n                      "
                              ),
                              _vm.errores.subtotal_iva_0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.subtotal_iva_0[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "iva",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.iva,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "iva", $$v)
                                },
                                expression: "form.iva"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      IVA\n                      "
                              ),
                              _vm.errores.iva
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.iva[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "ice",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.ice,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ice", $$v)
                                },
                                expression: "form.ice"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      ICE\n                      "
                              ),
                              _vm.errores.ice
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.ice[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "total",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.total,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total", $$v)
                                },
                                expression: "form.total"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Total\n                      "
                              ),
                              _vm.errores.total
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.total[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main-buttons" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "A",
                      expression: "estado !== 'A'"
                    }
                  ],
                  staticClass: "btn-success",
                  attrs: { type: "button" },
                  on: { click: _vm.guardarComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Guardar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-light btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.nuevoComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Nuevo")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N" && _vm.estado !== "A",
                      expression: "estado !== 'N' && estado !== 'A'"
                    }
                  ],
                  staticClass: "btn-danger btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.anularComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-ban" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Anular")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-bus200 btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.imprimirComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-print" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Imprimir")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N" && _vm.estado !== "A",
                      expression: "estado !== 'N' && estado !== 'A'"
                    }
                  ],
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.enviarCorreo }
                },
                [
                  _c("i", { staticClass: "fa fa-envelope-o" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Enviar correo")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N" && _vm.estado !== "A",
                      expression: "estado !== 'N' && estado !== 'A'"
                    }
                  ],
                  staticClass: "btn-success btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.facturar }
                },
                [
                  _c("i", { staticClass: "fa fa-envelope-o" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Facturar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N" && _vm.permiteClonar,
                      expression: "estado !== 'N' && permiteClonar"
                    }
                  ],
                  staticClass: "btn-primary btn--text",
                  on: { click: _vm.clonar }
                },
                [
                  _c("i", { staticClass: "fa fa-clone" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Clonar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-warning btn--text",
                  on: { click: _vm.generarOrdenTrabajo }
                },
                [
                  _c("i", { staticClass: "fa fa-briefcase" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Orden de trabajo")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.mostrarAuditorias }
                },
                [
                  _c("i", { staticClass: "fa fa-file" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Auditorías")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-secondary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.abrirLogs }
                },
                [
                  _c("i", { staticClass: "fa fa-file-o" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Logs")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-secondary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verAnterior }
                },
                [
                  _c("i", { staticClass: "fa fa-toggle-left" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Anterior")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-secondary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verSiguiente }
                },
                [
                  _c("i", { staticClass: "fa fa-toggle-right" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Siguiente")])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "85%",
            height: "auto",
            scrollable: "",
            name: "listaComprobantes"
          }
        },
        [
          _c("lista-comprobantes", {
            attrs: {
              vendedores: _vm.vendedores,
              tipoComprobante: _vm.tipoDocumento
            },
            on: { selected: _vm.cargarProforma }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "50%",
            name: "imprimir",
            height: "auto",
            scrollable: ""
          }
        },
        [_c("imprimir", { attrs: { id_comprobante: _vm.id_comprobante } })],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "50%",
            name: "auditorias",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("auditorias", {
            ref: "auditorias",
            attrs: { id_comprobante: _vm.id_comprobante },
            on: { cancelar: _vm.cancelarAuditorias }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información del comprobante")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Forma de pago")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información adicional")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Totales del comprobante")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e616359", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e616359","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Proforma.vue
// module id = 453
// module chunks = 0